import React, {useEffect} from 'react';
import {
  GridFooterContainer,
  GridFooterContainerProps,
} from '@mui/x-data-grid-pro';
import {Box} from '@mui/material';
import ArrButton from '../../../../common/arr-button/ArrButton';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import GridFooterPagination from './GridFooterPagination';
import './CustomFooter.scss';
import {t} from 'i18next';

export interface CustomFooterProps extends Partial<GridFooterContainerProps> {
  pageSizeOptions: number[];
  showExport: boolean;
  pageSize: number;
  pageCount: number;
  currentPageNumber: number;
  onClose: () => void;
  onExport: () => void;
  onPageSizeChange: (count: number) => void;
  onPageCountChange: (page: number) => void;
  onPageNumberChange: (page: number) => void;
}

const CustomFooter: React.FC<CustomFooterProps> = ({
  pageCount,
  currentPageNumber,
  pageSizeOptions,
  showExport,
  pageSize,
  onPageSizeChange,
  onPageCountChange,
  onClose,
  onExport,
  onPageNumberChange,
}) => {
  const handlePageSizeChange = (newPageSize: number) => {
    onPageSizeChange(newPageSize);
    onPageNumberChange(0);
  };

  useEffect(() => {
    onPageSizeChange(pageSize);
    onPageCountChange(pageCount);
  }, [pageSize, pageCount]);

  return (
    <GridFooterContainer className="custom-footer-container">
      <GridFooterPagination
        page={currentPageNumber}
        pageCount={pageCount}
        pageSize={
          pageSizeOptions.includes(pageSize) ? pageSize : pageSizeOptions[0]
        }
        pageSizeOptions={pageSizeOptions}
        onPageChange={onPageNumberChange}
        onPageSizeChange={handlePageSizeChange}
      />
      <Box className="footer-actions">
        <ArrButton
          variant="secondary"
          size="medium"
          onClick={onClose}
          dataTestId="custom-footer-close-button">
          {t(
            'productionsAndExports.createNewProduction.generate.modals.errors.close'
          )}
        </ArrButton>
        {showExport && (
          <ArrButton size="medium" onClick={onExport} dataTestId="custom-footer-export-button">
            <FileUploadOutlinedIcon className="export-icon" />
            {t(
              'productionsAndExports.createNewProduction.generate.modals.errors.export'
            )}
          </ArrButton>
        )}
      </Box>
    </GridFooterContainer>
  );
};

export const FooterWrapper: React.FC<any> = (props) => {
  const {
    onClose,
    onExport,
    pageSizeOptions,
    showExport,
    pageSize,
    onPageSizeChange,
    onPageCountChange,
    pageCount,
    currentPageNumber,
    onPageNumberChange,
  } = props;
  return (
    <CustomFooter
      onClose={onClose}
      onExport={onExport}
      pageSizeOptions={pageSizeOptions}
      showExport={showExport}
      pageSize={pageSize}
      onPageSizeChange={onPageSizeChange}
      onPageCountChange={onPageCountChange}
      pageCount={pageCount}
      onPageNumberChange={onPageNumberChange}
      currentPageNumber={currentPageNumber}
    />
  );
};

export default CustomFooter;
